import { ModalConfig, ModalOpenOptions } from '@services/components/ModalService/modal.types';
import { GenericConfirmModalComponent, GenericConfirmModalData } from '@shared/components/UI/generic-confirm-modal/generic-confirm-modal.component';

export const MODAL_CONFIG: ModalConfig = {
  size: 'md',
  closeOnBackdrop: true,
  closeOnEsc: true,
  showCloseButton: true,
  ariaLabelledby: 'modal-title',
  ariaDescribedby: 'modal-description',
};

export const MODAL_CONSTANTS = {
  PLACEHOLDER_CONSTANT_MODAL: {
    ...MODAL_CONFIG,
    title: 'Bienvenido',
    description: 'This is a simple modal with just a title and description. No custom component needed!',
  },
};

export const GENERIC_SERVICE_ERROR_MODAL: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Ocurrió un error',
  description: 'Hubo un problema al procesar la solicitud. Por favor, intentá de nuevo más tarde.',
};

export const TOO_MANY_REQUESTS_MODAL: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Demasiados intentos',
  description: 'Has intentado hacer esta acción muchas veces seguidas. Por favor, espera unos minutos e inténtalo de nuevo.',
};

export const SERVER_ERROR_MODAL: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Tenemos un problema',
  description: 'Algo falló de nuestro lado y ya estamos trabajando para resolverlo. Por favor, inténtalo de nuevo más tarde.',
};

export const COLOR_CONFLICT_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Color en uso',
};

export const DELETE_COLOR_CONFIRM_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Eliminar color',
};

export const DELETE_COLOR_BLOCKED_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Color en uso',
};

export const DELETE_PRODUCT_CONFIRM_MODAL: ModalOpenOptions<GenericConfirmModalData> = {
  ...MODAL_CONFIG,
  title: 'Eliminar producto',
  component: GenericConfirmModalComponent,
  closeOnBackdrop: false,
  closeOnEsc: false,
  data: {
    message: 'Esta acción es permanente. El producto será eliminado y no podrá ser recuperado. ¿Estás seguro de que quieres eliminarlo?',
    cancelButtonLabel: 'Cancelar',
    primaryButtonLabel: 'Eliminar',
  },
};

export const LOAD_ERROR_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Error al cargar',
  description: 'No se pudieron cargar los datos. ¿Querés intentarlo de nuevo?',
  closeOnBackdrop: false,
  closeOnEsc: false,
  showCloseButton: false,
};

export const SELECT_PRODUCT_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Cambio De Producto Seleccionado',
  size: 'md',
};

export const ORDER_DETAIL_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Detalle del pedido',
  size: 'lg',
};

export const SHIP_ORDER_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Marcar como enviado',
  size: 'sm',
  closeOnBackdrop: false,
  closeOnEsc: false,
};

export const CANCEL_ORDER_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Cancelar pedido',
  size: 'md',
  closeOnBackdrop: false,
  closeOnEsc: false,
};

export const RETURN_ORDER_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Marcar como devuelto',
  size: 'md',
  closeOnBackdrop: false,
  closeOnEsc: false,
};

export const REMOVE_FEATURED_CONFIRM_MODAL_CONFIG: ModalConfig = {
  ...MODAL_CONFIG,
  title: 'Eliminar producto',
  closeOnBackdrop: false,
  closeOnEsc: false,
};

export const buildDeactivateShippingBoxConfirmModal = (boxLabel: string): ModalOpenOptions<GenericConfirmModalData> => ({
  ...MODAL_CONFIG,
  title: 'Desactivar caja',
  component: GenericConfirmModalComponent,
  closeOnBackdrop: false,
  closeOnEsc: false,
  data: {
    message: `La caja "${boxLabel}" deja de usarse para cotizar desde ya. Los productos que solo caben en ella quedarán solo para retiro en tienda. ¿Quieres desactivarla?`,
    cancelButtonLabel: 'Cancelar',
    primaryButtonLabel: 'Desactivar',
  },
});
